import React, { useEffect } from "react";
import Nav from "../Pages/Nav/Nav";
import { Box, Toolbar } from "@mui/material";
import Footer from "../Pages/mainPage/Footer";
import { Helmet } from "react-helmet-async";

const ProtectedRoutes = (props) => {
  const meta = props.data.metaTag;
  useEffect(() => {
   
 if(meta.script){
    // JSON-LD script
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify(meta.scriptData);
    document.head.appendChild(script);

    // Clean up on unmount
    return () => {
      document.head.removeChild(script);
    };
  }
  }, [props.data]);

  return (
    <Box>
      <Helmet>
        <title>{meta.title}</title>
        <meta name="title" content={meta.title} />
        <meta name="description" content={meta.description} />
        <meta name="keywords" content={meta.keyword} />
        <meta name="author" content="Solver Thoughts Technologies" />
        <meta name="robots" content="index, follow" />

        {meta.canonical && (
          <link rel="canonical" href={meta.canonicalLink} />
        )}

        {/* Open Graph */}
        <meta property="og:title" content={meta.ogTitle} />
        <meta property="og:description" content={meta.ogDescription} />
        <meta property="og:url" content={meta.ogUrl} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={meta.ogImage} />

        {/* Twitter Meta */}
        <meta name="twitter:card" content={meta.twitterCard} />
        <meta name="twitter:title" content={meta.twitterTitle} />
        <meta name="twitter:description" content={meta.twitterDescription} />
        <meta name="twitter:image" content={meta.twitterImage} />
      </Helmet>

      <Nav />
      <Box sx={{ mt: "-10vh" }}>
        <Toolbar />
        {props.children}
      </Box>
      <Footer />
    </Box>
  );
};

export default ProtectedRoutes;
